module.exports = __webpack_public_path__ + "img/chris (48).35f18369.jpg";